<h2 mat-dialog-title>{{ (data.setup ? 'TWO_FACTOR.SETUP_TITLE' : 'TWO_FACTOR.NEW_CODES_TITLE') | translate }}</h2>

<mat-dialog-content>
  @if (data.setup) {
    <div class="uvDialogSteps mb-3">
      @for (s of steps; track s; let i = $index) {
        <div class="paragraphText secondaryTextColor" [class.active]="s === step()">
          <span class="mr-1">{{ i + 1 }}.</span>
          <span class="uvStepLabel">{{ ('TWO_FACTOR.STEP_' + s.toUpperCase()) | translate }}</span>
        </div>
      }
    </div>
  }

  @switch (step()) {
    @case ('scan') {
      <p class="paragraphText secondaryTextColor mb-3">{{ 'TWO_FACTOR.STEP_SCAN_HINT' | translate }}</p>

      <div class="setupQr">
        @if (qrCode(); as src) {
          <img [src]="src" [alt]="'TWO_FACTOR.QR_ALT' | translate" width="200" height="200">
        }
      </div>

      @if (onPhone && addToAppLink) {
        <a mat-button class="btn outlineActionButton setupAddToApp" [href]="addToAppLink">{{ 'TWO_FACTOR.ADD_TO_APP' | translate }}</a>
        <p class="captionText secondaryTextColor mb-3">{{ 'TWO_FACTOR.ADD_TO_APP_HINT' | translate }}</p>
      }

      <p class="paragraphText secondaryTextColor mb-2">{{ 'TWO_FACTOR.KEY_HINT' | translate }}</p>
      <div class="setupKey panelAccentBG">
        <code class="uvCode">{{ keyGroups }}</code>
        <button mat-button type="button" class="btn" (click)="copyKey()">{{ 'GENERAL.COPY' | translate }}</button>
      </div>
      <p class="captionText secondaryTextColor mt-2 mb-0">
        {{ 'TWO_FACTOR.KEY_ACCOUNT' | translate: { account: data.setup!.Account, issuer: data.setup!.Issuer } }}
      </p>
    }

    @case ('confirm') {
      <p class="paragraphText secondaryTextColor mb-3">{{ 'TWO_FACTOR.STEP_CONFIRM_HINT' | translate }}</p>

      <mat-form-field appearance="outline" class="customMatFormField cutFieldBottom">
        <mat-label>{{ 'LOGIN.CODE_LABEL' | translate }}</mat-label>
        <input #codeInput type="text" matInput [formControl]="code" [readonly]="expired"
          inputmode="numeric" autocomplete="one-time-code" (input)="normalizeCode()" (keydown.enter)="confirmCode()">
      </mat-form-field>

      @if (error) {
        <mat-error class="mt-2">{{ error.key | translate: error.params }}</mat-error>
      }
    }

    @case ('codes') {
      <p class="paragraphText secondaryTextColor mb-3">{{ 'TWO_FACTOR.STEP_CODES_HINT' | translate }}</p>

      <div class="setupCodes panelAccentBG">
        @for (c of codes; track c) {
          <code class="uvCode">{{ c }}</code>
        }
      </div>

      <div class="uvActions mb-3">
        <button mat-button type="button" class="btn" (click)="copyCodes()">{{ 'GENERAL.COPY' | translate }}</button>
        <button mat-button type="button" class="btn" (click)="saveCodes()">{{ 'TWO_FACTOR.DOWNLOAD' | translate }}</button>
      </div>

      <mat-checkbox class="uvCheckboxFlush" [formControl]="saved">{{ 'TWO_FACTOR.SAVED_CHECK' | translate }}</mat-checkbox>
    }
  }
</mat-dialog-content>

<mat-dialog-actions>
  @switch (step()) {
    @case ('scan') {
      <button mat-button type="button" class="btn actionButton" (click)="step.set('confirm')">{{ 'GENERAL.NEXT' | translate }}</button>
      <button mat-button type="button" class="btn outlineActionButton" mat-dialog-close>{{ 'GENERAL.CANCEL' | translate }}</button>
    }
    @case ('confirm') {
      @if (expired) {
        <button mat-button type="button" class="btn actionButton" [mat-dialog-close]="false">{{ 'GENERAL.CLOSE' | translate }}</button>
      } @else {
        <button mat-button type="button" class="btn actionButton" [disabled]="confirming" (click)="confirmCode()">{{ 'CONFIRMATION.CONFIRM' | translate }}</button>
        <button mat-button type="button" class="btn outlineActionButton" (click)="error = null; step.set('scan')">{{ 'GENERAL.BACK' | translate }}</button>
      }
    }
    @case ('codes') {
      <button mat-button type="button" class="btn actionButton" [disabled]="!saved.value" (click)="finish()">{{ 'TWO_FACTOR.DONE' | translate }}</button>
    }
  }
</mat-dialog-actions>
